// extracted by mini-css-extract-plugin
export default {"root":"IconSpinner_root__6JFKA","lightSpinner":"IconSpinner_lightSpinner__TLMom"};